import React, {
    useContext
} from 'react';
import CollectionNamePlate from './CollectionNamePlate';
import BreadcrumbsCustom from 'shared/components/Breadcrumb';
import {
    KBContext
} from '../knowledgeBuilderContext/KBGlobalContext';
import {
    useLocation, useNavigate, useParams
} from 'react-router-dom';
import {
    Button
} from 'shared/components/ui/button';
import {
    ChevronLeft
} from 'lucide-react';

const KBHeader = () => {
    const {
        collectionDetails, getMemberNameByUserId, metaMap, handleCheckMetadata
    } = useContext(KBContext);
    const location = useLocation();
    const navigate = useNavigate();
    const { oragID, subOragID } = useParams();
    const isDeStudio = location.pathname.includes('/de-studio/');

    return (
        <>
            <div className="px-7 py-6 pb-0">
                <div className='ml-6 scale-90 origin-left'>
                    {isDeStudio ? (
                        <Button
                            variant="ghost"
                            size="sm"
                            onClick={() => navigate(`/organizations/${oragID}/sub/${subOragID}/de-studio/library?tab=collections`)}
                            className="h-8 px-2 text-muted-foreground hover:text-primary transition-colors flex items-center gap-1.5 -ml-2"
                        >
                            <ChevronLeft className="h-4 w-4" />
                            <span className="text-xs font-medium">Back to Library</span>
                        </Button>
                    ) : (
                        <BreadcrumbsCustom maxPaths={2} />
                    )}
                </div>
                <CollectionNamePlate
                    collectionName={collectionDetails?.name}
                    createdBy={
                        getMemberNameByUserId(collectionDetails?.createdBy)
                    }
                    createdAt={new Date(collectionDetails?.created).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    })}
                    metaMap={metaMap}
                    collectionId={collectionDetails?._id}
                    handleCheckMetadata={handleCheckMetadata} />
            </div>
        </>
    );
};

export default KBHeader;